<div class="wrapper" [class.design-modern]="design === 'modern'">
  <ks-canvas-editor [imageUrl]="imageUrl" />

  <div
    *ngIf="!(isLoadedImage$ | async) && !(isErrorLoadedImage$ | async)"
    class="loader"
  >
    <fa-icon [icon]="['fas', 'spinner']" class="loader__spin"></fa-icon>
  </div>

  <div *ngIf="isErrorLoadedImage$ | async" class="error-message">
    <fa-icon [icon]="['fas', 'warning']" class="icon"></fa-icon>
    <span>Ошибка загрузки изображения, обратитесь в службу поддержки!</span>
  </div>

  <div class="controls">
    <span (click)="onCloseEditor()" class="close-button">
      <fa-icon [icon]="['fas', 'times']"></fa-icon>
    </span>
    <div class="wrapper-main-column">
      <div class="wrapper-block-btn">
        <div class="wrapper-btn">
          <dx-button
            (onClick)="onCreatePencil()"
            [focusStateEnabled]="false"
            [hint]="'gallery.editor.PENCIL' | translate"
            [type]="getType(typeConfigKonva.PENCIL)"
            class="btn"
            [class.btn-modern]="design === 'modern'"
            [class.btn-active]="
              mode() === typeConfigKonva.PENCIL && design === 'modern'
            "
          >
            <app-icon
              *ngIf="design === 'modern'"
              [iconName]="['Others', 'pencil']"
              [color]="'white'"
            ></app-icon>
            <fa-icon *ngIf="design !== 'modern'" icon="pencil"></fa-icon>
          </dx-button>
          <dx-button
            (onClick)="onCreateLine()"
            [focusStateEnabled]="false"
            [hint]="'gallery.editor.LINE' | translate"
            [type]="getType(typeConfigKonva.LINE)"
            class="btn"
            [class.btn-modern]="design === 'modern'"
            [class.btn-active]="
              mode() === typeConfigKonva.LINE && design === 'modern'
            "
          >
            <app-icon
              *ngIf="design === 'modern'"
              [iconName]="['Character', 'minus']"
              [color]="'white'"
            ></app-icon>
            <fa-icon *ngIf="design !== 'modern'" icon="minus"></fa-icon>
          </dx-button>
          <dx-button
            (onClick)="onCreateArrow()"
            [focusStateEnabled]="false"
            [hint]="'gallery.editor.ARROW' | translate"
            [type]="getType(typeConfigKonva.ARROW)"
            class="btn"
            [class.btn-modern]="design === 'modern'"
            [class.btn-active]="
              mode() === typeConfigKonva.ARROW && design === 'modern'
            "
          >
            <app-icon
              *ngIf="design === 'modern'"
              [iconName]="['Arrows', 'arrow-left-down']"
              [color]="'white'"
            ></app-icon>
            <fa-icon
              *ngIf="design !== 'modern'"
              [icon]="['fas', 'arrow-circle-left']"
            ></fa-icon>
          </dx-button>
        </div>
        <div class="wrapper-btn">
          <dx-button
            (onClick)="onCreateRect()"
            [focusStateEnabled]="false"
            [hint]="'gallery.editor.RECTANGLE' | translate"
            [type]="getType(typeConfigKonva.RECT)"
            class="btn"
            [class.btn-modern]="design === 'modern'"
            [class.btn-active]="
              mode() === typeConfigKonva.RECT && design === 'modern'
            "
          >
            <app-icon
              *ngIf="design === 'modern'"
              [iconName]="['Connect', 'anchor']"
              [color]="'white'"
            ></app-icon>
            <fa-icon
              *ngIf="design !== 'modern'"
              [icon]="['fas', 'stop']"
            ></fa-icon>
          </dx-button>

          <dx-button
            (onClick)="onClickAccordion()"
            [hint]="'gallery.editor.CREATE_TEXT' | translate"
            class="btn"
            [class.btn-modern]="design === 'modern'"
            [class.btn-active]="isTextAccordionOpen() && design === 'modern'"
            type="normal"
          >
            <app-icon
              *ngIf="design === 'modern'"
              [iconName]="['Edit', 'text']"
              [color]="'white'"
            ></app-icon>
            <fa-icon
              *ngIf="design !== 'modern'"
              [icon]="['fas', 'commenting']"
            ></fa-icon>
          </dx-button>

          <dx-button
            (onClick)="onDeleteElement()"
            [disabled]="!(selectedElement$ | async)"
            [hint]="'gallery.editor.REMOVE' | translate"
            [width]="36"
            class="btn-danger"
            [class.btn-danger-modern]="design === 'modern'"
            stylingMode="contained"
            type="danger"
          >
            <app-icon
              *ngIf="design === 'modern'"
              [iconName]="['Edit', 'delete-one']"
              [color]="'white'"
            ></app-icon>
            <fa-icon *ngIf="design !== 'modern'" icon="trash"></fa-icon>
          </dx-button>
        </div>
      </div>
      <form [formGroup]="form">
        <div [class.open]="isTextAccordionOpen()" class="text-accordion">
          <div class="body">
            <textarea
              [formControl]="form.controls.text"
              [placeholder]="'gallery.editor.PLACEHOLDER' | translate"
            ></textarea>
            <dx-button
              (onClick)="onCreateText()"
              [disabled]="form.invalid"
              class="btn"
              type="default"
            >
              <fa-icon [icon]="['fas', 'check']"></fa-icon>
            </dx-button>
          </div>
        </div>
      </form>
    </div>

    <div class="wrapper-slider">
      <div class="slider-field">
        <span class="label">{{
          "gallery.editor.SELECT_COLOR" | translate
        }}</span>
        <dx-color-box
          (onValueChanged)="onColorChanged($event)"
          [acceptCustomValue]="false"
          [applyButtonText]="'gallery.editor.ACCEPT' | translate"
          [elementAttr]="{ custom: 'DERFETRTDSFS' }"
          [value]="color$ | async"
        >
        </dx-color-box>
      </div>

      <div class="slider-field">
        <span class="label">{{
          "gallery.editor.SELECT_WIDTH" | translate
        }}</span>
        <dx-slider
          (onValueChanged)="onChangeWidth($event)"
          [max]="10"
          [min]="0"
          [step]="1"
          [tooltip]="sliderTooltip"
          [value]="width$ | async"
        ></dx-slider>
      </div>
    </div>
    <dx-button
      (onClick)="onAllClear()"
      [text]="'gallery.editor.CLEAR' | translate"
      class="btn"
      [class.btn-clear-modern]="design === 'modern'"
      type="normal"
    ></dx-button>
    <dx-button
      (onClick)="onSave()"
      [disabled]="isChangesEditor$ | async"
      [text]="'gallery.editor.SAVE' | translate"
      class="btn"
      [class.btn-save-modern]="design === 'modern'"
      type="default"
    ></dx-button>
  </div>
</div>

<dx-popup
  (onHidden)="showConfirmCancelChangesModal()"
  *ngIf="showConfirmCancelChangesModal()"
  [dragEnabled]="true"
  [height]="'auto'"
  [showTitle]="false"
  [visible]="true"
  [width]="400"
>
  <div class="popup__confirm-message">
    {{ "notification.EXIT_WITHOUT_SAVING" | translate }}
  </div>
  <div class="popup__buttons-block">
    <dx-button
      (onClick)="onCancelChanges()"
      [icon]="'todo'"
      [text]="'notification.YES' | translate"
    ></dx-button>
    <dx-button
      (onClick)="showConfirmCancelChangesModal.set(false)"
      [icon]="'remove'"
      [text]="'notification.NO' | translate"
    ></dx-button>
  </div>
</dx-popup>
